import { AddressModel } from "src/app/models/address.model";
import { AppSignature } from "src/app/models/app-signature";
import { Board, GradeModel } from "src/app/models/master.model";
import { InstituteModel } from "../../institute/models/institute-model";
import { InstituteAcademicYear, InstituteGradeDivision } from "../../institute-academic-year/models/institute-academic-year";
import { FileTransferModel } from "src/app/models/file-transfer";
import { GradeDivisionAcademicYearDTO, GradeDivisionModel } from "../../institute-time-table/models/institute-time-table.model";
import { user } from "../../staff-management/models/staff.model";
import { StudentHealthAndNutritionModel } from "../../nutrition-assessment/models/student-health-nutrion";

export class StudentModel extends AppSignature {
    studentID: string;
    firstName: string;
    lastName: string;
    gender: string;
    dateOfBirth: string;
    email: string;
    phone: string;
    parentInstituteID: string;
    profileImage: string;
    isActive: boolean;
    parentGuardianID: string;
    guardianRelationship: number = 0;;
}

export class StudentDTO {
    student: StudentModel = new StudentModel();
    studentHealthAndNutrition: StudentHealthAndNutritionModel = new StudentHealthAndNutritionModel();
    studentHealthAndNutritionList: Array<StudentHealthAndNutritionModel> = [];
    institute: InstituteModel = new InstituteModel();
    address: AddressModel = new AddressModel();
    grade: GradeModel = new GradeModel();
    studentGuardian: StudentGuardian = new StudentGuardian();
    board: Board = new Board();
    studentRegistration: StudentRegistration = new StudentRegistration();
    instituteGradeDivision: InstituteGradeDivision = new InstituteGradeDivision();
    profileImage: FileTransferModel = new FileTransferModel();
    studentAcademicYears: Array<InstituteAcademicYear> = [];
    academicYear: InstituteAcademicYear = new InstituteAcademicYear();
    loginRecord: any;
    hasCustomer: boolean;
}
export class currentStudent extends StudentDTO {
    role: any;
}

export class StudentRegistration extends AppSignature {
    parentInstituteBoardMapID: string;
    parentStudentID: string;
    parentGradeID: string;
    section: string;
    rollNumber: string;
    registrationDate: string;
    isActive: boolean;
    status: string;
    parentInstituteGradeDivisionID: string;
    parentInstituteAcademicYearID: string;
}

export class StudentRegistrationDTO extends GradeDivisionAcademicYearDTO {
    student: StudentModel;
    studentRegistration: StudentRegistration;
}



export class StudentGuardian extends AppSignature {
    name: string = '';
    phone: string = '';
    email: string = '';
    guardianID: string;
    parentInstituteID: string;
}

export class studentGuardianDTO {
    studentGuardian: StudentGuardian = new StudentGuardian();
    students: Array<StudentModel> = [];
    userNameType: number = 0;
    user: user = new user();
}

export class StudentDetailsDTO extends StudentRegistrationDTO {
    hasAttendance: boolean;
    hasTimeTable: boolean;
    feesPaid: number;
    totalFees: number;
    lastActive: string;
    profileImage: FileTransferModel = new FileTransferModel();
}